// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, OAuthProvider, signInWithPopup } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCJO_3wi1bw1Q4BwnHrePUjsoklO36Uytg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "aptarro-onboarding.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://aptarro-onboarding-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "aptarro-onboarding",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "aptarro-onboarding.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "397615098057",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:397615098057:web:6c951b4102be163b4f0518",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-C682QB9RDP"
};

// Validate required config
if (!firebaseConfig.projectId) {
  console.error('Firebase configuration error: Missing projectId');
  throw new Error('Firebase configuration is incomplete. Please check environment variables.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Create Microsoft provider
const provider = new OAuthProvider('microsoft.com');
provider.setCustomParameters({
  tenant: process.env.REACT_APP_AZURE_TENANT_ID || 'ab2b4400-697d-478a-a603-7674de98cd49'
});

// Function to sign in with Microsoft using Firebase
export const signInWithMicrosoft = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error('Error signing in with Microsoft:', error);
    throw error;
  }
};
